import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import DataTable from "../../../components/shared/DataTable";
import SearchInput from "../../../components/shared/SearchInput";
import Pagination from "../../../components/shared/Pagination";
import { statusBadgeClass, formatDate } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function LabList() {
  const queryClient = useQueryClient();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery(
    ["admin-labs", page, search],
    () => api.get(`/admin/labs?page=${page}&search=${search}`),
    { keepPreviousData: true }
  );

  const approveMutation = useMutation(
    (id) => api.post(`/admin/labs/${id}/approve`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("admin-labs");
        toast.success("Lab approved");
      },
    }
  );

  const rejectMutation = useMutation(
    (id) => api.post(`/admin/labs/${id}/reject`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("admin-labs");
        toast.success("Lab rejected");
      },
    }
  );

  const columns = [
    { key: "name", label: "Lab Name", sortable: true },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
    { key: "address", label: "Address" },
    {
      key: "createdAt",
      label: "Registered",
      render: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.status)}>{row.status}</span>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) =>
        row.status === "pending" ? (
          <div className="flex gap-2">
            <button
              onClick={() => approveMutation.mutate(row.id)}
              className="text-xs px-3 py-1 bg-green-100 text-green-700 rounded-lg hover:bg-green-200"
            >
              Approve
            </button>
            <button
              onClick={() => rejectMutation.mutate(row.id)}
              className="text-xs px-3 py-1 bg-red-100 text-red-700 rounded-lg hover:bg-red-200"
            >
              Reject
            </button>
          </div>
        ) : (
          <span className="text-slate-400 text-xs">—</span>
        ),
    },
  ];

  return (
    <div className="space-y-4">
      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Search labs…"
        className="w-72"
      />
      <DataTable
        columns={columns}
        data={data?.data || []}
        loading={isLoading}
        emptyMessage="No labs found."
      />
      <Pagination
        page={page}
        totalPages={data?.totalPages || 1}
        onPageChange={setPage}
      />
    </div>
  );
}
